import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PortalModule, TemplatePortal } from '@angular/cdk/portal';
import { Observable } from 'rxjs';
import { PortalBridgeService } from '../portal-bridge.service';

@Component({
  selector: 'markant-platform-modal',
  standalone: true,
  imports: [CommonModule, PortalModule],
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent {
  portal$: Observable<TemplatePortal[]>;

  constructor(private portalBridge: PortalBridgeService) {
    this.portal$ = this.portalBridge.portals$;
  }
}
